import { getQueryArgs } from '@wordpress/url';

export default function getAuthHashParams() {
	// getQueryArgs wants a full URL, so I'll LIE!
	return getQueryArgs( `https://example.org/?${document.location.hash.substring( 1 )}` );
}
